// extracted by mini-css-extract-plugin
module.exports = {"category":"CategoryMenuStyle_category__1M0pc","categoryItem":"CategoryMenuStyle_categoryItem__zQZ5x"};